import React from 'react';
import Navbar from '@/components/layout/Navbar';
import Footer from '@/components/layout/Footer';
import AdminCheckWrapper from '@/components/analytics/admin/AdminCheckWrapper';
import AVVDashboard from '@/components/admin/avv/AVVDashboard';
import AGBDashboard from '@/components/admin/agb/AGBDashboard';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { FileText, Scale } from 'lucide-react';

const LegalDocuments = () => {
  return (
    <AdminCheckWrapper>
      {() => (
        <div className="min-h-screen flex flex-col bg-background">
          <Navbar />
          <main className="flex-1 py-16 px-4 max-w-[1440px] mx-auto w-full">
            <div className="mb-8">
              <h1 className="text-3xl font-bold">Rechtsdokumente</h1>
              <p className="text-muted-foreground mt-2">
                Generatoren für AVV und AGB – rechtskonforme Dokumente für Kooperationspartner
              </p>
            </div>

            <Tabs defaultValue="avv" className="space-y-6">
              <TabsList>
                <TabsTrigger value="avv" className="gap-2">
                  <FileText className="h-4 w-4" />
                  AVV-Generator
                </TabsTrigger>
                <TabsTrigger value="agb" className="gap-2">
                  <Scale className="h-4 w-4" />
                  AGB-Generator
                </TabsTrigger>
              </TabsList>

              <TabsContent value="avv">
                <AVVDashboard />
              </TabsContent>

              <TabsContent value="agb">
                <AGBDashboard />
              </TabsContent>
            </Tabs>
          </main>
          <Footer />
        </div>
      )}
    </AdminCheckWrapper>
  );
};

export default LegalDocuments;
